import { useReducer } from "react";

const STATES = {
    IDLE: "IDLE",
    CALLING: "CALLING",
    RINGING: "RINGING",
    CONNECTING: "CONNECTING",
    CONNECTED: "CONNECTED",
    ENDED: "ENDED",
    FAILED: "FAILED",
    RECONNECTING: "RECONNECTING", // ✅ ADDED THIS MISSING KEY
};

const reducer = (state, action) => {
    switch (action.type) {
        case "CALL_START": return STATES.CALLING;
        case "INCOMING_CALL": return STATES.RINGING;
        case "ANSWER_SENT": return STATES.CONNECTING;
        case "CONNECTED": return STATES.CONNECTED;
        case "END": return STATES.ENDED;
        case "FAIL": return STATES.FAILED;
        case "RESET": return STATES.IDLE;
        case "RECONNECTING": return STATES.RECONNECTING;
        default: return state;
    }
};

export const useCallStateMachine = () => {
    const [state, dispatch] = useReducer(reducer, STATES.IDLE);
    return {
        callState: state,
        callStart: () => dispatch({ type: "CALL_START" }),
        incomingCall: () => dispatch({ type: "INCOMING_CALL" }),
        answerSent: () => dispatch({ type: "ANSWER_SENT" }),
        connected: () => dispatch({ type: "CONNECTED" }),
        endCall: () => dispatch({ type: "END" }),
        failCall: () => dispatch({ type: "FAIL" }),
        reset: () => dispatch({ type: "RESET" }),
    };
};